// pages/AnabolicsProducts.jsx
import React, { useEffect } from "react";
import "./Products.css"; // Reuse same CSS

import Bolda from "./CarouselImages/Anabolics/Bolda.jpeg";
import CutMix from "./CarouselImages/Anabolics/CutMix.jpeg";
import DecA from "./CarouselImages/Anabolics/DecA.jpeg";
import GainBlend from "./CarouselImages/Anabolics/GainBlend.jpeg";
import Masterone from "./CarouselImages/Anabolics/Masterone.jpeg";
import Primobolan from "./CarouselImages/Anabolics/Primobolan.jpeg";
import TestC from "./CarouselImages/Anabolics/TestC.jpeg";
import TestP from "./CarouselImages/Anabolics/TestP.jpeg";
import TrenA from "./CarouselImages/Anabolics/TrenA.jpeg";
import TrenE from "./CarouselImages/Anabolics/TrenE.jpeg";
import TrenH from "./CarouselImages/Anabolics/TrenH.jpeg";
import TriTren from "./CarouselImages/Anabolics/TriTren.jpeg";
import Winstrol from "./CarouselImages/Anabolics/Winstrol.jpeg";

const anabolics = [
  { name: "Bolda", description: "$57", image: Bolda },
  { name: "Cut Mix", description: "$53", image: CutMix },
  { name: "Gain Blend", description: "$62", image: GainBlend },
  { name: "Masterone", description: "$66", image: Masterone },
  { name: "Primobolan", description: "$55", image: Primobolan },
  { name: "Test-C", description: "$76", image: TestC },
  { name: "Test-P", description: "$79", image: TestP },
  { name: "Tren-A", description: "$82", image: TrenA },
  { name: "Tren-E", description: "$54", image: TrenE },
  { name: "Tren-H", description: "$56", image: TrenH },
  // { name: "Tri Tren", description: "$63", image: TriTren },
  { name: "Winstrol", description: "$67", image: Winstrol },
];

const AnabolicsProducts = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="products-page">
      <h1>Anabolics Steroids</h1>
      <div className="product-grid">
        {anabolics.map((item, index) => (
          <div className="product-card" key={index}>
            <img src={item.image} alt={item.name} className="product-img" />
            <div className="product-info">
              <h2>{item.name}</h2>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnabolicsProducts;
